import MicroModal from 'micromodal';
import { setAnchorTagWithParams } from '../../../util/common_util';


class App {
    constructor() {
      if(!this.redirectToMain()){
        console.log('-------START-------');

        // 로그인/로그아웃 안씀
        document.querySelector('.logout')?.addEventListener('click', () => {
          window.GNBLogout();
        });
        document.querySelector('.login')?.addEventListener('click', () => {
          window.GNBLogin();
        });

        MicroModal.init({
          awaitCloseAnimation: true,
          debugMode: true,
          onShow: function(modal) {
            console.log('micromodal open!');
          },
          onClose: function(modal) {
            console.log('micromodal close!');
          }
        });

        this.addEvents();

        // a 태그 href에 현재 searchParmas 붙이기
        [...document.querySelectorAll('a')].map(ElAnchor => setAnchorTagWithParams(ElAnchor));

      }
    }

    redirectToMain(){
      // if(new Date() > new Date('2023-02-20:11:00')){
      //   document.location.href = '/';
      //   return true;
      // }
      return false;
    }

    addEvents() {
      // const btnApply = document.querySelector('.intro__link-info')!;
      // btnApply?.addEventListener('click', (e) => {
      //     e.preventDefault();
      //     document.getElementById('apply').scrollIntoView({ behavior: 'smooth' });
      // });

      //트래킹코드
      const registerbtn = document.querySelector('.intro__link-register')!;
      registerbtn.addEventListener('click', ()=>{
        // console.log('registerbtn');

        try{
          window.dataLayer.push({
            'event': 'customEvent',
            'customEventCategory': '클릭',
            'customEventAction': 'Content Container - 버튼 클릭',
            'customEventLabel': '2단계신청양식작성버튼클릭'
          });
        }catch{
          //
        }

        // [5]
        try{
          window.gtag('event', 'conversion', {
            'send_to': 'AW-11010511490/qhtlCI_87JcYEIKlnIIp',
            'value': 5000.0,
            'currency': 'KRW',
          });
        }catch{
          //
        }

      });
    }
}
new App();
